export const BULK_EDIT_IDENTIFIER_COLUMNS = [
  "Site",
  "Capacity Year",
  "Status",
  "Program Type",
  "Timeline",
  "Region",
  "Cluster",
  "LMSC/SC-SC",
  "Original Launch Year",
  "SC Type",
] as const;

export const BULK_EDIT_MAX_ROWS = 50;
export const BULK_EDIT_PAGE_SIZE = 10;
export const SAVE_TIMEOUT_MS = 30000;

export const FIELD_GROUP_BUILDING_ATTRIBUTES = "buildingAttributes";
export const FIELD_GROUP_PRODUCTIVITY = "productivity";
